export default "__VITE_ASSET__Dy50ltwA__"